module.exports = __webpack_public_path__ + "img/logo-loja-remo.61589b6c.svg";